import React, { useState, useEffect } from "react";
import {
  Button,
} from "reactstrap";
import PropTypes from "prop-types";


const Loading = (props) => {
  // console.log(props);

  return (
    <>
      {
        props.show == true &&
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "#000000", opacity: "0.3", zIndex: "2000", backdropFilter: "none" }}>
          <div
            className="spinner-border text-primary"
            style={{ position: "fixed", top: "50%", left: "50%", zIndex: "2500", width: "70px", height: "70px" }}
            role="status"
          >
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      }
    </>
  )
}

Loading.propTypes = {
  show: PropTypes.any,
};

export default Loading;